import React from 'react';
import { IconButton, classNamesFunction } from '@fluentui/react';
var getClassNames = classNamesFunction();
export var CoherencePanelNavigationBase = function (props) {
    var _a;
    var onRenderNavigationContent = props.onRenderNavigationContent, backButton = props.backButton, styles = props.styles, theme = props.theme, panelProps = props.panelProps, defaultRender = props.defaultRender;
    var classNames = getClassNames(styles, { theme: theme });
    return (React.createElement(React.Fragment, null,
        (backButton === null || backButton === void 0 ? void 0 : backButton.onClick) && (React.createElement("div", { className: classNames.headerButtonsContainer },
            React.createElement(IconButton, { iconProps: { iconName: 'Back' }, onClick: backButton.onClick, ariaLabel: (_a = backButton.ariaLabel) !== null && _a !== void 0 ? _a : 'Back', className: classNames.backButton }))), onRenderNavigationContent === null || onRenderNavigationContent === void 0 ? void 0 :
        onRenderNavigationContent(),
        defaultRender(panelProps)));
};
//# sourceMappingURL=CoherencePanelNavigation.base.js.map